<template>
    <div class="card">
        <div class="card-header bg-info">
            <h3 class="my-0">Tareas programadas (todos los clientes)</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col">
                    <button type="button"
                            class="btn btn-custom btn-sm mt-2 mr-2 mb-3"
                            @click.prevent="clickCreate()">
                        <i class="fa fa-plus-circle"></i> Nueva
                    </button>
                </div>
            </div>
            <el-table :data="tableData" style="width: 100%">
                <el-table-column label="Clase" prop="class"></el-table-column>
                <el-table-column label="Hora de ejecución" prop="execution_time"></el-table-column>
                <el-table-column label="Ultima ejecución" prop="updated_at"></el-table-column>
                <el-table-column label="Cantidad de sistemas" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" :disabled="scope.row.total_clients === 0" @click="clickLogs(scope.row)">
                            Ver ({{ scope.row.total_clients }})
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="Acciones" width="120">
                    <template slot-scope="scope">
                        <el-button block size="mini" type="danger"
                                   @click="handleDelete(scope.$index, scope.row)">Eliminar</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <system-task-configuration-all-tenant-form
            :showDialog.sync="showDialog"
            @refresh="refresh">
        </system-task-configuration-all-tenant-form>
        <el-dialog title="Listado de sistemas que se ejecutaron la tarea programada" :visible.sync="showLogs" width="70%"
            @open="loadLogs" @closed="resetLogs">
        <div v-loading="loading_logs">
            <el-table :data="logs" style="width: 100%">
                <el-table-column label="Cliente" prop="client_name"></el-table-column>
                <el-table-column label="Hostname" prop="hostname" width="200"></el-table-column>
                <el-table-column label="Ultima ejecución" prop="executed_at" width="150"></el-table-column>
                <el-table-column prop="documents_count" width="110" align="center"
                                 label="Cantidad documentos consultados">
                    <template slot="header" slot-scope="scope">
                        Cantidad<br>documentos<br>consultados
                    </template>
                </el-table-column>
                <el-table-column label="Estado" width="90" align="center">
                    <template slot="header" slot-scope="scope">
                        Estado
                                <el-tooltip class="item"
                                            content="OK: Se ejecutó la tarea programada correctamente"
                                            effect="dark"
                                            placement="top-start">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="scope.row.success ? 'success' : 'danger'">
                            {{ scope.row.success ? 'OK' : 'Error' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="Log" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="clickDetail(scope.row)">
                            <i class="fa fa-search"></i>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                :total="pagination.total"
                :current-page.sync="pagination.current_page"
                :page-size="pagination.per_page"
                @current-change="loadLogs"
                layout="total, prev, pager, next"
            ></el-pagination>
        </div>

        <el-dialog title="Log del cliente" :visible.sync="showDetail" width="60%" append-to-body>
            <h5 class="mb-1">{{ detail.client_name }}</h5>
            <small class="text-muted">{{ detail.hostname }} — {{ detail.executed_at }}</small>
            <pre class="mt-2 mb-0"
                style="white-space: pre-wrap; max-height: 55vh; overflow: auto;">{{ detail.log }}</pre>
        </el-dialog>
    </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                resource: 'system-tasks',
                showDialog: false,
                tableData: [],
                showLogs: false,
                loading_logs: false,
                logs: [],
                pagination: {},
                task_id: null,
                showDetail: false,
                detail: {}
            }
        },
        created() {
            this.refresh();
        },
        methods: {
            refresh() {
                this.$http.post(`/${this.resource}/tables`).then((response) => {
                    this.tableData = response.data;
                }).catch((error) => { console.log(error); });
            },
            handleDelete(index, row) {
                this.$http.delete(`/${this.resource}/${row.id}`).then((response) => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.tableData.splice(index, 1);
                    } else {
                        this.$message.error(response.data.message);
                    }
                }).catch((error) => {
                    this.$message.error(error.response.data.message);
                });
            },
            clickCreate() {
                this.showDialog = true;
            },
            clickLogs(row) {
                this.task_id = row.id;
                this.pagination = { current_page: 1 };
                this.showLogs = true;          // el @open dispara loadLogs
            },
            loadLogs() {
                this.loading_logs = true;

                this.$http.get(`/${this.resource}/${this.task_id}/logs`, {
                    params: { page: this.pagination.current_page }
                }).then((response) => {
                    this.logs = response.data.data;
                    this.pagination = response.data.meta;
                }).catch((error) => {
                    this.$message.error(error.response.data.message);
                }).then(() => {
                    this.loading_logs = false;
                });
            },
            clickDetail(row) {
                this.detail = row;
                this.showDetail = true;
            },
            resetLogs() {
                this.logs = [];
                this.pagination = {};
                this.task_id = null;
                this.showDetail = false;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/views/system/configuration/task_configuration_all_tenant.vue